// src/lib/prefetchVehicles.js
import api from "../axiosConfig";
import { getStoredToken, getStoredUser } from "./authStorage";

function decodePayload(tok) {
  try {
    const b64 = tok.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(b64));
  } catch {
    return null;
  }
}

function resolveCompanyId() {
  const tok =
    getStoredToken() ||
    window.localStorage.getItem("authToken") ||
    "";
  const p = tok ? decodePayload(tok) : null;

  const fromJwt = p?.company_id ?? p?.companyId ?? null;
  if (Number.isFinite(Number(fromJwt)) && Number(fromJwt) > 0) {
    return Number(fromJwt);
  }

  const direct =
    window.sessionStorage.getItem("companyId") ||
    window.sessionStorage.getItem("company_id") ||
    window.localStorage.getItem("companyId") ||
    window.localStorage.getItem("company_id") ||
    null;

  if (Number.isFinite(Number(direct)) && Number(direct) > 0) {
    return Number(direct);
  }

  const storedUser = getStoredUser();
  const fromUser =
    storedUser?.company_id ??
    storedUser?.companyId ??
    null;

  if (Number.isFinite(Number(fromUser)) && Number(fromUser) > 0) {
    return Number(fromUser);
  }

  return null;
}

function safeRead(key) {
  try { return JSON.parse(window.localStorage.getItem(key) || "null"); }
  catch { return null; }
}

function safeWrite(key, payload) {
  try { window.localStorage.setItem(key, JSON.stringify(payload)); }
  catch {}
}

export async function prefetchVehiclesSummaries({ force = false } = {}) {
  const companyId = resolveCompanyId();
  const baseKey = companyId ? `company:${companyId}` : "company:unknown";

  const trucksKey = `${baseKey}:trucks:summary:v1`;
  const trailersKey = `${baseKey}:trailers:summary:v1`;

  // não spammar se já existe cache recente
  const tCache = safeRead(trucksKey);
  const rCache = safeRead(trailersKey);
  const now = Date.now();
  const MAX_AGE_MS = 60_000; // 1 min (ajusta se quiseres)

  const hasFreshTrucks =
    !!tCache?.items && Array.isArray(tCache.items) && (now - (tCache.ts || 0) < MAX_AGE_MS);
  const hasFreshTrailers =
    !!rCache?.items && Array.isArray(rCache.items) && (now - (rCache.ts || 0) < MAX_AGE_MS);

  if (!force && hasFreshTrucks && hasFreshTrailers) return;

  try {
    const [trucksRes, trailersRes] = await Promise.allSettled([
      (!force && hasFreshTrucks) ? null : api.get("/trucks/summary"),
      (!force && hasFreshTrailers) ? null : api.get("/trailers/summary"),
    ]);

    if (trucksRes?.status === "fulfilled") {
      const items = Array.isArray(trucksRes.value.data) ? trucksRes.value.data : [];
      safeWrite(trucksKey, { ts: Date.now(), items, meta: {} });
    }

    if (trailersRes?.status === "fulfilled") {
      const items = Array.isArray(trailersRes.value.data) ? trailersRes.value.data : [];
      safeWrite(trailersKey, { ts: Date.now(), items, meta: {} });
    }
  } catch {
    // ignore
  }
}
